import { ReduxState } from '../AppLoader/types';

export const selectUserSignupCsmEmail = (state: ReduxState) =>
  state.userSignup.csmEmail;
export const selectUserSignupOrgs = (state: ReduxState) =>
  state.userSignup.possibleOrgs;
export const selectUserSignupEmail = (state: ReduxState) =>
  state.userSignup.userEmail;
